import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';
import { OrderedMap } from 'immutable';

import Brand from 'models/brand';
import { Vehicle as VehicleModel } from 'models/vehicles';

import VehicleForm from 'components/account/saved-vehicles/vehicle-form';

import updateVehicleCreator from 'action-creators/vehicles/update-vehicle';
import AccountHeadline from 'components/common/account/account-headline';
import trackEventCreator from 'action-creators/analytics/track-event';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  dismissPage: PropTypes.func.isRequired,
  selectedVehicleId: PropTypes.string,
  vehicles: PropTypes.instanceOf(OrderedMap).isRequired,
  updateVehicle: PropTypes.func.isRequired,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedVehicleId: null,
};

class EditVehicleWrapper extends Component {
  constructor(props) {
    super(props);

    this.dismissPage = this.dismissPage.bind(this);
  }

  dismissPage() {
    if (window.confirm('Are you sure you want to dismiss your changes?')) {
      this.props.dismissPage();
    }
  }

  render() {
    const { vehicles, selectedVehicleId, updateVehicle, brand, app, trackEvent } = this.props;
    const vehicle = vehicles.get(selectedVehicleId);
    return (
      <div>
        <AccountHeadline brand={brand} headline="MANAGE SAVED VEHICLES" app={app} trackEvent={trackEvent} />
        <div className="heavy-shadowed area dismissable">
          <div className="dismiss-button clickable" onClick={this.dismissPage} />
          <div className="row">
            <div className="col-md-10 col-md-offset-1 padding-0">
              <h4 className="h4-sg text-color-slate text-weight-medium with-bottom-margin-2x">EDIT VEHICLE</h4>
              <div className="col-md-10 padding-0">
                <VehicleForm vehicle={vehicle} saveOrUpdateVehicle={updateVehicle} brand={brand} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EditVehicleWrapper.propTypes = propTypes;
EditVehicleWrapper.defaultProps = defaultProps;

const dismissPage = () => push('/account/vehicles');

const mapStateToProps = (state) => {
  const {
    brand,
  } = state.brand;
  const {
    vehicles,
    selectedVehicleId,
    vehicle,
  } = state.account;
  const { name: app } = state.app;
  return {
    brand,
    vehicles,
    selectedVehicleId,
    vehicle,
    app,
  };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    dismissPage,
    updateVehicle: updateVehicleCreator,
    trackEvent: trackEventCreator,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(EditVehicleWrapper);
